import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';

const FILES_BASE = 'https://files.tnonetwork.com';
const PEDRO_SHOW_LOGO = `${FILES_BASE}/shows/logo/pedroconlasmascotas.png`;

const pillars = [
  {
    icon: (
      <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    ),
    title: 'Fase de Preventa: El set de la confianza',
    subtitle:
      'Recibimos a organizadores y patrocinadores en estudio para entrevistas exclusivas que despiertan expectativa y validan el valor del evento.',
  },
  {
    icon: (
      <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Cobertura en terreno: Pedro Scutaro',
    subtitle:
      'Pedro recorre la Expo con cercanía, criterio y sensibilidad para conversar con marcas, veterinarios, especialistas y animalitos protagonistas.',
  },
  {
    icon: (
      <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Ecosistema TNO: la huella digital',
    subtitle:
      'Señal TNO, TNO Digest y contenido On-Demand para que la experiencia viaje más allá de los 2 días del evento.',
  },
];

const AboutSection = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });

  return (
    <Box>
      <Box marginBottom={{ xs: 4, sm: 8, md: 10 }}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          gutterBottom
          color="primary"
          align="center"
        >
          Nuestra misión
        </Typography>
        <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
          Darle voz a las historias que conmueven
        </Typography>
        <Typography variant="h6" component="p" color="textSecondary" align="center" maxWidth={760} margin="0 auto">
          En TNO Network entendemos que una mascota no es solo un animalito: es
          parte de la familia. Por eso ponemos 12 años de ingeniería de medios al
          servicio de Expo Mascotas Caracas para que cada historia llegue con
          ternura, orden y calidad profesional.
        </Typography>
      </Box>
      <Grid container spacing={4} direction={isMd ? 'row' : 'column-reverse'}>
        <Grid item xs={12} md={6} data-aos={isMd ? 'fade-right' : 'fade-up'}>
          <Typography
            sx={{ textTransform: 'uppercase', fontWeight: 600 }}
            gutterBottom
            color="primary"
          >
            Pilares de la cobertura
          </Typography>
          <Typography variant="h5" fontWeight={700} gutterBottom>
            Preventa, terreno y presencia digital sostenida
          </Typography>
          <List disablePadding>
            {pillars.map((item, index) => (
              <ListItem key={index} disableGutters sx={{ alignItems: 'flex-start' }} data-aos="fade-up">
                <ListItemAvatar>
                  <Box
                    component={Avatar}
                    variant="rounded"
                    bgcolor={`${theme.palette.primary.light}33`}
                    color={theme.palette.primary.dark}
                  >
                    {item.icon}
                  </Box>
                </ListItemAvatar>
                <ListItemText
                  primary={item.title}
                  secondary={item.subtitle}
                  primaryTypographyProps={{ fontWeight: 600 }}
                />
              </ListItem>
            ))}
          </List>
        </Grid>
        <Grid item xs={12} md={6} container justifyContent="center" alignItems="center" data-aos={isMd ? 'fade-left' : 'fade-up'}>
          <Box
            component={Card}
            boxShadow={4}
            borderRadius={2}
            overflow="hidden"
            sx={{ bgcolor: theme.palette.alternate.main }}
          >
            <Box p={3}>
              <Typography variant="overline" color="primary" fontWeight={700}>
                Host oficial
              </Typography>
              <Typography variant="body2" color="primary" fontWeight={600} sx={{ mb: 0.5 }}>
                TNO Network · Cobertura especial para Expo Mascotas Caracas
              </Typography>
              <Typography variant="h5" fontWeight={700} gutterBottom>
                Pedro Scutaro
              </Typography>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                Pedro será la cara visible de esta experiencia. Su carisma, su
                afinidad con el mundo animal y su capacidad para conectar con las
                marcas convierten cada recorrido en una pieza de contenido cercana,
                útil y profundamente compartible.
              </Typography>
              <Typography variant="body2" fontWeight={700} color="primary">
                Host del programa Pedro con las Mascotas
              </Typography>
              <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
                <Typography variant="caption" color="textSecondary" display="block" gutterBottom>
                  Programa ancla que cubre el evento
                </Typography>
                <Box
                  component="img"
                  src={PEDRO_SHOW_LOGO}
                  alt="Pedro con las Mascotas"
                  sx={{
                    height: 72,
                    width: 'auto',
                    maxWidth: 320,
                    objectFit: 'contain',
                    mb: 1,
                    display: 'block',
                  }}
                />
                <Typography variant="h6" fontWeight={700} color="primary">
                  Pedro con las Mascotas
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  El programa será la ventana oficial para transmitir la emoción,
                  los consejos y las historias más memorables de la Expo a toda la
                  comunidad TNO.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AboutSection;
